import React from "react";
import "./filterMenuList.scss";
import SearchBarWithIcon from "../SearchBarWithIcon";

const FilterMenuList = (props) => {
  const {
    menuItemList,
    toggleItems,
    handleFilterSearch,
    show_filter_searchbar,
    showApplyResetBtn,
    isMultiSelect,
    showGreyTick,
    tickIcon,
    selectedTickIcon,
    customFooter,
    handleApplyButton,
    handleResetButton,
    show_menu_title,
    placeholderForSearch,
    customMenu,
    showCustomMenu,
  } = props;

  // Create UI ==>
  const displayMenuList = () => {
    return (
      <div className="filter-menu-list" style={{ ...props.styles }}>
        {show_filter_searchbar && (
          <div className="p-2">{filterSeacrhbar()}</div>
        )}
        {show_menu_title && (
          <div className="p-2">
            <h6>{show_menu_title}</h6>
          </div>
        )}
        <div className="dropdown">
          {showCustomMenu ? customMenu() : menuDropdown()}
        </div>
        {customFooter && customFooter()}
        {showApplyResetBtn && <div>{applyAndResetBtn()}</div>}
      </div>
    );
  };

  const menuDropdown = () => {
    return (
      menuItemList &&
      menuItemList.map((item, index) => (
        <div
          onClick={() => toggleItems(item)}
          className="filter-menu-list-item"
          key={index}
        >
          {tickIcon ? (
            <img
              alt=""
              src={item.selected ? selectedTickIcon : tickIcon}
              className="filter-menu-list-tick-icon"
            />
          ) : (
            <i
              className="fa fa-check filter-menu-list-icon"
              style={{
                color: isMultiSelect
                  ? item.selected
                    ? "#17BAE0"
                    : "#A3A9B7"
                  : item.selected
                  ? "#17BAE0"
                  : showGreyTick
                  ? "#A3A9B7"
                  : "transparent",
              }}
              aria-hidden="true"
            ></i>
          )}
          <span className="filter-menu-list-title">{item.name}</span>
        </div>
      ))
    );
  };

  const filterSeacrhbar = () => {
    return (
      <SearchBarWithIcon
        inputCallBack={handleFilterSearch}
        placeholder={placeholderForSearch}
        isClearable={true}
      />
    );
  };

  const applyAndResetBtn = () => {
    return (
      <div className="apply-reset-btn-container">
        <button className="btn reset-btn" onClick={handleResetButton}>
          Reset All
        </button>
        <button className="btn apply-btn" onClick={handleApplyButton}>
          Apply
        </button>
      </div>
    );
  };
  // <===

  return <>{displayMenuList()}</>;
};

export default FilterMenuList;
